import { Spine } from '@esotericsoftware/spine-pixi-v7'
import * as PIXI from 'pixi.js'
// import { Spine } from 'pixi-spine';

import gsap from 'gsap';
import { banderitasCollection, containers, gameAssets, showManualPopup, shownNetworkErrorPopup } from './gameUI.js';
import { animateMultiplier, fallAnimation } from './animations.js';
import { isOnline, scratchScore } from './networkService.js';
import { GAME_STATES, RESULTS } from './constants.js';
import  { gameData, networkData, demoState } from './data.js';
import { setPumpIdleAnimation, setPumpTransitionAnimation } from './pump.js';
import { playrip1, playrip2, playrip3, playrip4, playRipReveal1 } from './soundManager.js';
import { autoPlayRound, turboPlayRound } from './gameLogic.js';
import { hideAnticipationAnimation } from './jackpotPanel.js';
import { scaleFactor } from './utility.js';

const animatingFlags = new Set();
const clickQueue = [];
let apiInFlight = false;

function createSpine(spineObj, animationName, angle = 0){
    // if(!spineObj) spineObj = new Spine(PIXI.Assets.get('banderitas').spineData)
    if(!spineObj) spineObj = Spine.from({ skeleton: "banderitas", atlas: "banderitasAtlas"
       });  
      
    spineObj.state.setAnimation(0, animationName, true)
    spineObj.state.timeScale = 1
    spineObj.angle = angle
  
    containers.flagsContainer.addChild(spineObj)

    spineObj.resize = (x, y, w, h) => {
      spineObj.x = x
      spineObj.y = y

      spineObj.initialY = spineObj.y
      spineObj.finalY = spineObj.y + 200
      const expandFactor = 0.75
      const scale = scaleFactor(gameAssets.gameScreen.width, 1080)

      containers.flagsContainer.x = w/2
      containers.flagsContainer.y = h/2 + 5
      containers.flagsContainer.scale.set(scale * expandFactor)
      
    }
  
    return spineObj
  }
  
export function createSpineObject(objIndex, spineObj, animationName, angle = 0) {
    const spineObjF = createSpine(spineObj, animationName, angle);
    
    spineObjF.eventMode = 'static'
    spineObjF.interactive = true
    spineObjF.buttonMode = true
    spineObjF.cursor = 'pointer'
    spineObjF.index = objIndex
    spineObjF.initialY = spineObjF.y
    spineObjF.finalY = spineObjF.y
    spineObjF.initialHeight = spineObjF.height
    spineObjF.initialAngle = spineObjF.angle
    gameAssets.spineObj.push(spineObjF)
    spineObjF.fallAnimation = (gameObj, flag, value = 0, f1 = true) => {
      fallAnimation(gameObj, flag); 
      
     if(flag){
      playRipReveal1(true);
     } 
     else if(checkOccurence(value) && f1){
      playrip4(true)
     }
     else if ([1, 2, 5, 2.5, 25, 50].includes(gameData.flagValue) && f1) {
        playrip1(true);
      } else if ([250, 500, 1000].includes(gameData.flagValue) && f1) {
          playrip2(true);
      } else if (gameData.flagValue === 10000 && f1) {
          playrip3(true);
      }
    };
  
  spineObjF.multiplierAnimation = (gameObj, executeCallback = true, flag = false, flagIndex = null, localValue = null) => {
    gsap.delayedCall(1, () => {
      animateMultiplier(gameObj, () => {
        if (executeCallback) {
          gsap.delayedCall(0.7, () => {
            if (flagIndex !== null) animatingFlags.delete(flagIndex);
            callbackFunction(flag, localValue);
          });
        }
      });
    });
  };   
    
    spineObjF.on('pointerdown', async (event) => {
      if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
        const online = await isOnline();
        if(online || demoState.isDemo){
          clickFlag(spineObjF);
        } else {
          showManualPopup("Internet\nDisconnected");
        }
      }
    });

     
  
    return spineObjF
  }

  const checkOccurence = (value) => {
   return gameData.scratchedValues.filter(num => num === value).length >= 2
  }
  
export function createSpineBGObject(spineObj, animationName, angle = 0){
    const spineObjBG = createSpine(spineObj, animationName, angle)
    spineObjBG.visible = false

    spineObjBG.multiplierValue = new PIXI.BitmapText('200', {
      fontName: 'font-export',
      fontSize: 3,
      letterSpacing:-30
    })

    spineObjBG.multiplierValue.y = 150
    spineObjBG.multiplierValue.x = 0
    spineObjBG.multiplierValue.alpha = 0
    spineObjBG.multiplierValue.zIndex = 500
    spineObjBG.multiplierValue.anchor.set(0.5)
    spineObjBG.multiplierValue.scale.set(2.7)
    spineObjBG.goldIdle = () => {
      spineObjBG.state.setAnimation(0, "gold_idle", true)
    }
    spineObjBG.flagReveal = () => {
      spineObjBG.state.setAnimation(0, "reveal", false)
      spineObjBG.state.addAnimation(0, "special_idle", 5, true)
    }
    spineObjBG.flagSpecialReveal = () => {
      spineObjBG.state.setAnimation(0, "reveal_special", false)
      spineObjBG.state.addAnimation(0, "special_idle", 5, true)
    }

    spineObjBG.addChild(spineObjBG.multiplierValue)
    return spineObjBG
  }

export const clickFlag = async (spineObjF) => {
  if(gameData.isPopupOpen) return;

  if (animatingFlags.has(spineObjF.index)) return;  

  if (clickQueue.some(q => q.index === spineObjF.index)) return; 
  
  if(!networkData.dataPlaceBet) return;
  
  if(!networkData.ticketDetails && !demoState.isDemo){
        shownNetworkErrorPopup();
        return;
    }

    gameData.firstScratchDone = true;
    clickQueue.push(spineObjF);
    processNextClick();
}

const processNextClick = async () => {
    if (apiInFlight || clickQueue.length === 0) return;
    const spineObjF = clickQueue.shift();
    if (animatingFlags.has(spineObjF.index)) {
        processNextClick();
        return;
    }

    apiInFlight = true;
    animatingFlags.add(spineObjF.index);

    const scoreIndex = spineObjF.index - 1;
    if(networkData.isJackpot) hideAnticipationAnimation();
    gameData.flagInProgress = true;

    if(networkData.scratchResult != RESULTS.WON && networkData.scratchResult != RESULTS.LOST) 
        setPumpTransitionAnimation(gameData.scratchDoneNumber);

    const value = await scratchScore(scoreIndex);
    
     const localMultiplierValue = demoState.isDemo 
        ? value 
        : networkData?.dataScratchScore?.gameResult?.scratchedValue;
    
    gameData.flagValue = localMultiplierValue;

    apiInFlight = false;   
     if (gameData.autoPlay && networkData.scratchResult !== RESULTS.WON && networkData.scratchResult !== RESULTS.LOST) {
        gsap.delayedCall(0.5, () => {
            if (gameData.autoPlay && gameData.scratchIndex.length < 9) {
                autoPlayRound();
            }
        });
    }
    processNextClick();    
     if(localMultiplierValue) {
        spineObjF.fallAnimation(spineObjF, false, localMultiplierValue);
        spineObjF.under.visible = true;

        let formattedValue;
        if (localMultiplierValue >= 1000) {
            formattedValue = (localMultiplierValue / 1000).toFixed(0) + "K"; 
        } else {
            formattedValue = localMultiplierValue.toString(); 
        }

        if (localMultiplierValue < 99) {
            spineObjF.under.multiplierValue.fontName = "font-bronze";
        } else if (localMultiplierValue >= 99 && localMultiplierValue <= 1000) {
            spineObjF.under.multiplierValue.fontName = "font-blue";
        } else {
            spineObjF.under.multiplierValue.fontName = "font-red";
        }

        spineObjF.under.multiplierValue.text = formattedValue;

        spineObjF.multiplierAnimation(
            spineObjF.under.multiplierValue, 
            true, 
            false, 
            spineObjF.index,
            localMultiplierValue
        );
        networkData.dataScratchScore = null;

        if(shouldPulsate(localMultiplierValue)){
            pulsateNumbers(localMultiplierValue);
        }
    } else {
        animatingFlags.delete(spineObjF.index);
    }
}

export const pulsateNumbers = (multi) => {
  if(multi == 1000) multi = "1K";
  else if(multi == 10000) multi = "10K";
  
  banderitasCollection.map((value,index)=> {        
    if(value.under.multiplierValue.text == multi){
      
      gsap.timeline({ repeat: -1, yoyo: true }) 
      .to(value.under.multiplierValue.scale, {
        x:3.2,
        y:3.2 ,
        duration: 0.2,
        ease: "power1.inOut", 
      });
    }
  })
}

const shouldPulsate = (value) => {  
  return gameData.scratchedValues.filter(num => num === value).length === 2;
}

const callbackFunction = (flag, localValue = null) => {  
    gameData.gameState = GAME_STATES.IDLE;
    gameData.scratchDoneNumber++;

    if(gameData.scratchDoneNumber == 9){
        gameData.scratchDoneNumber = 8;
    }
    if(networkData.scratchResult != RESULTS.WON && !flag && networkData.scratchResult != RESULTS.LOST){        
        setPumpIdleAnimation(gameData.scratchDoneNumber);
    }

    gameData.flagInProgress = false;

    if(gameData.turboPlay && !gameData.flagInProgress && gameData.scratchIndex.length !== 9){
        turboPlayRound();
    } else if(gameData.autoPlay && !gameData.flagInProgress && gameData.scratchIndex.length !== 9){
        autoPlayRound();
    } else if(!gameData.autoPlayInProgress) {
        gameAssets.menuGraphic.visible = false;
        gameAssets.menu.interactive = true;
        gameAssets.spineObj.map((item) => { item.interactive = true; });
    }

    processNextClick();
}
  

export const resetFlags = () => {
    clickQueue.length = 0;
    animatingFlags.clear();
    apiInFlight = false;

    const scratchResult = networkData.scratchResult;
    banderitasCollection.forEach(flag => {
        flag.visible = true;
        flag.scale.set(1);
        flag.under.visible = false;
        flag.under.alpha = 1;
        if(scratchResult === RESULTS.WON) flag.under.goldIdle();
    });
}

export const revealPreviousFlags = (scratchedScoresIndexes, scratchedScore, flag = true) => {
  if(scratchedScoresIndexes?.length > 0){
    gameData.gameState = GAME_STATES.FLAG_ANIMATION
    gameData.scratchDoneNumber = scratchedScoresIndexes.length - 1
    
    scratchedScoresIndexes.forEach((score, i) => {
      if(scratchedScore[i]) {
        banderitasCollection[score].fallAnimation(banderitasCollection[score], flag ? i==0 : flag, 0, false)
        banderitasCollection[score].under.visible = true

        let formattedValue;

          if (scratchedScore[i] >= 1000) {
            formattedValue = (scratchedScore[i] / 1000).toFixed(0) + "K"; 

          } else {
            formattedValue = scratchedScore[i].toString(); 
          }
          if (scratchedScore[i] < 99) {
            banderitasCollection[score].under.multiplierValue.fontName = "font-bronze";
          } else if (scratchedScore[i] >= 99 && scratchedScore[i] <=  1000) {
            banderitasCollection[score].under.multiplierValue.fontName = "font-blue";
          } else {
            banderitasCollection[score].under.multiplierValue.fontName = "font-red";
          }
        banderitasCollection[score].under.multiplierValue.text = formattedValue
        banderitasCollection[score].multiplierAnimation(banderitasCollection[score].under.multiplierValue, i==0)
      }

    })

  }
}